import React, { useRef } from "react";
import { Heart } from "lucide-react";

// Which SET is being browsed: the public catalogue, or the signed-in viewer's
// own favourites. Rendered only when signed in -- a signed-out visitor has no
// favourites, so an empty tab would be a dead end, not a discovery.
//
// This is a view switch, not a filter and not a sort, so it gets neither
// family's colour: the selected segment is white-on-white/10 like SortSegments
// (it orders/scopes the page rather than narrowing it), and it sits on its own
// line above the genre chips because it changes what those chips even apply to.
const OPTIONS = [
  { value: "", label: "All kits" },
  { value: "favorites", label: "Favourites" },
];

export default function ViewTabs({ view, onChange }) {
  const btnRefs = useRef([]);

  const move = (delta) => {
    const idx = OPTIONS.findIndex((o) => o.value === view);
    const nextIdx = (idx + delta + OPTIONS.length) % OPTIONS.length;
    onChange(OPTIONS[nextIdx].value);
    btnRefs.current[nextIdx]?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      move(1);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      move(-1);
    }
  };

  return (
    <div
      role="radiogroup"
      aria-label="Which kits to show"
      onKeyDown={handleKeyDown}
      className="inline-flex rounded border border-white/10 bg-[#1a1a1e] p-0.5"
    >
      {OPTIONS.map((opt, i) => {
        const selected = view === opt.value;
        return (
          <button
            key={opt.value || "all"}
            ref={(el) => (btnRefs.current[i] = el)}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => !selected && onChange(opt.value)}
            className={`inline-flex h-8 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-[3px] px-3 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5500] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505] ${
              selected ? "bg-white/10 text-white" : "text-[#A1A1AA] hover:text-white"
            }`}
          >
            {opt.value === "favorites" && (
              <Heart size={14} strokeWidth={1.5} fill={selected ? "currentColor" : "none"} />
            )}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
